import { QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';
import { apiClient } from '~/services/api-service';
import { CouponQrResponse, CreateCouponQrPayload, UpdateCouponQrPayload } from '~/types/coupon';

export const createCouponQR = (payload: CreateCouponQrPayload) => {
  return apiClient.post(`/microsite/${QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON}/`, payload);
};

export const getCouponQRById = (id: number | string) => {
  return apiClient.get<CouponQrResponse>(`/microsite/${QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON}/${id}/`);
};

export const updateCouponQR = ({ payload, id }: { payload: UpdateCouponQrPayload; id: number | string }) => {
  return apiClient.patch(`/microsite/${QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON}/${id}/`, payload);
};
